import './index.scss';
import { __ } from '@wordpress/i18n';
import classnames from 'classnames';

import { positionlist } from './positionlist.js';
import  ResetAttributes  from '../../../general/ResetButton.js'

import { useState, useEffect } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';
import { useSelect } from '@wordpress/data';

import { InspectorControls } from '@wordpress/block-editor';
import {	
	SelectControl,
	Button,
	RangeControl,
	TextControl,
	ToggleControl,
	Flex, 
	FlexItem,
	ButtonGroup
} from '@wordpress/components';


const allowedBlocks = ['core/group'];
const apositionDefaults = {
	aOn: false,
	type: '',
	horizontal: '',
	vertical: '',
	offsetX: ['', '', ''],	
	offsetY: ['', '', ''],
	zIndex: ['', '', ''],
};


const addAttributes = (settings,name) => {
	
	if (!allowedBlocks.includes(name)) return settings;	

	if (typeof settings.attributes !== 'undefined' ) {
		settings.attributes = {
			...settings.attributes,		
			aposition: {
				type: 'object',
				default: apositionDefaults,
			},
		}
	}
	return settings;
}


const addInspectorControl = (BlockEdit) => (props) => {
	
	if (!allowedBlocks.includes(props.name)) return <BlockEdit {...props} />;

	const { attributes, setAttributes, isSelected } = props;
	const { aposition = {} } = attributes;

  const orgDefaults = {
		...apositionDefaults,
		...(attributes.aposition || {}),
	}

	const { 
		aOn, 
		type, 
		horizontal, 
		offsetX, 
		vertical, 
		offsetY, 
		zIndex 
	} = orgDefaults;
	
	const isDifferentFromDefault = JSON.stringify({ ...aposition, aOn: undefined }) !== JSON.stringify({ ...apositionDefaults, aOn: undefined });

	const updateObject = (obj, key, newVal) => ({ ...obj, [key]: newVal });
	const updateArray = (list, index, newVal) => {
		const listsCopy = [...list];
		listsCopy[index] = newVal;
		return listsCopy;
	}

	const reset = () => {
		setAttributes({
			aposition: {
				...aposition,
				offsetX: apositionDefaults.offsetX,
				offsetY: apositionDefaults.offsetY,
				zIndex:  apositionDefaults.zIndex,
			},
		});
	};

	
	const [syncViewport, setSyncViewport] = useState(false);
	const [breakPoint, setBreakPoint] = useState(0);

	useEffect(() => {
		const update = () => {
			let temp = 'Desktop';
			if (breakPoint === 1) temp = 'Tablet';
			if (breakPoint === 2) temp = 'Mobile';
			if (syncViewport) wp.data.dispatch('core/editor').setDeviceType(temp);
		};
		update();
	}, [syncViewport, breakPoint]);


	return (
		<>
			<BlockEdit {...props} />

			<InspectorControls group="position">			
				<Flex direction="column" style={{ marginTop: "1rem", gap: "1rem" }}> 		

					<Flex>
						<FlexItem>
							<ToggleControl
								label={__('Enable Position', 'aver')}
								checked={aOn}
								onChange={(val) => setAttributes({ aposition: {...aposition, aOn: val }})}
							/>
						</FlexItem>
						<FlexItem>
							{ isDifferentFromDefault && (
								<ResetAttributes
									onConfirm={() => {
										setAttributes({
											aposition: apositionDefaults
										});								
									}}
								/> 
							)}
						</FlexItem>
					</Flex>					

					{ aOn && (<>						
						<SelectControl
							label={__('Position', 'aver')}
							options={positionlist}
							value={type}
							onChange={(newval) => setAttributes({ aposition: {...aposition, type: newval }})}
						/>

						{['absolute', 'fixed', 'relative', 'sticky', 'absolute-middle'].includes(type) && ( <>										

								<Flex>
									<FlexItem className="button-frame">
										<Button icon="welcome-view-site" label="Sync Viewport" onClick={() => setSyncViewport(!syncViewport)}	isPressed={syncViewport} />
										<Button icon="undo"	label="Reset All"	onClick={()=> reset()}	/>
									</FlexItem>
									<FlexItem className="button-frame">
										<Button	icon="desktop" isPressed={breakPoint === 0}	onClick={() => setBreakPoint(0)} label=">1024px" />
										<Button icon="tablet"	isPressed={breakPoint === 1} onClick={() => setBreakPoint(1)}	label="≥782px" />
										<Button	icon="smartphone"	isPressed={breakPoint === 2} onClick={() => setBreakPoint(2)}	label="<782px"/>
									</FlexItem>
								</Flex>									

								{ type !== 'absolute-middle' && (
									<>											
										<Flex style={{ alignItems: 'flex-end' }}>
											<FlexItem style={{flexGrow:1}}>
												<TextControl
													label={__(`Horizontal Offset(px)[${breakPoint}]`, 'aver')}
													type="number"
													value={offsetX[breakPoint]}													
													onChange={(val) =>
														setAttributes({	aposition: {...aposition, offsetX: updateArray(offsetX, breakPoint, val) }}) }
												/>
											</FlexItem>
											<FlexItem className="button-frame" style={{width: '85px'}}>
												<Button icon="arrow-left-alt2"  isPressed={horizontal === 'left'} title="left" onClick= {() => setAttributes({ aposition: { ...aposition, horizontal: 'left'  }})} />
												<Button icon="arrow-right-alt2" isPressed={horizontal === 'right'} title="right" onClick={() => setAttributes({ aposition: { ...aposition, horizontal: 'right' }})} />													
											</FlexItem>
										</Flex>											
									
										<Flex style={{ alignItems: 'flex-end' }}>
											<FlexItem  style={{flexGrow:1}}>
												<TextControl
													label={__(`Vertical Offset(px)[${breakPoint}]`, 'aver')}
													type="number"
													value={offsetY[breakPoint]}
													onChange={(val) =>
														setAttributes({	aposition: {  ...aposition,  offsetY: updateArray(offsetY, breakPoint, val) }})
													}
												/>
											</FlexItem>
										
											<FlexItem className="button-frame" style={{width: '85px'}}>
												<Button icon="arrow-up-alt2"   isPressed={vertical === 'top'} title="top" onClick={() => setAttributes({ aposition: { ...aposition, vertical: 'top'    }})} />
												<Button icon="arrow-down-alt2" isPressed={vertical === 'bottom'} title="bottom" onClick={() => setAttributes({ aposition: { ...aposition, vertical: 'bottom' }})} />												
											</FlexItem>
											
										</Flex>								
									</>
								)}

								<TextControl
									label={__(`z-Index[${breakPoint}]`, 'aver')}
									onChange={(newval) =>
										setAttributes({ aposition: {...aposition, zIndex: updateArray(zIndex, breakPoint, newval)}})
									}									
									type="number"
									value={zIndex[breakPoint]}
									__nextHasNoMarginBottom={true}
								/>

						</>	)}
					</>	)}

				</Flex>
			</InspectorControls>
		
		</>
	);
}


const applyExtraClassEditor = (BlockListBlock) => (props) => {

	if (!allowedBlocks.includes(props.name)) return <BlockListBlock {...props} />	

	const { attributes, wrapperProps, className } = props;
  const orgDefaults = {
		...apositionDefaults,
		...(attributes.aposition || {}),
	}

	const { 
		aOn, 
		type, 
		horizontal, 
		offsetX, 
		vertical, 
		offsetY, 
		zIndex 
	} = orgDefaults;

	if (!aOn || !type) return <BlockListBlock {...props} />;


	const currentDevice = useSelect((select) => {
    return select( 'core/editor' ).getDeviceType();
  }, []);
	const breakPoint = { Desktop: 0, Tablet: 1, Mobile: 2 }[currentDevice];

	const getFallback = (list, index) => {
		if (list?.[index]) return list[index];
		if (index === 2 && list?.[1] !== '') return list[1];
		if (index === 2 && list?.[0] !== '') return list[0];
		if (index === 1 && list?.[0] !== '') return list[0];
		return '';
	};

	
	const cssstyle = {
		...wrapperProps?.style,
		...(type === 'absolute-middle') && { position:'absolute',top:'50%',left:'50%',transform:'translate(-50%, -50%)' },
		...(getFallback(zIndex, breakPoint) !== '' && { zIndex: getFallback(zIndex, breakPoint) }),
		...(type !== 'absolute-middle' ) && { position: type },		
		...(type !== 'absolute-middle' && horizontal === 'left'   && getFallback(offsetX, breakPoint) !== '' && { left: getFallback(offsetX, breakPoint) + 'px' }),
		...(type !== 'absolute-middle' && horizontal === 'right'  && getFallback(offsetX, breakPoint) !== '' && { right: getFallback(offsetX, breakPoint) + 'px' }),
		...(type !== 'absolute-middle' && vertical   === 'top'    && getFallback(offsetY, breakPoint) !== '' && { top: getFallback(offsetY, breakPoint) + 'px' }),
		...(type !== 'absolute-middle' && vertical   === 'bottom' && getFallback(offsetY, breakPoint) !== '' && { bottom: getFallback(offsetY, breakPoint) + 'px' }),
	};
	

	// Build class names
	const classes = classnames(className, {
		[`a-${horizontal}-h a-${vertical}-v`]: type && type !== 'absolute-middle',
	});

	return (
		<BlockListBlock
			{ ...props }
			wrapperProps={ { style : cssstyle } } 	
			className={ classes }
		/>
	)
}


// clean up the attributes saved in database
const applyExtraClassSave = (extraProps, blockType, attributes) => {
	
	if (!allowedBlocks.includes(blockType?.name)) {
		return extraProps;
	}

	const { aposition } = attributes;
	if (!aposition) return extraProps;	
	
	const isDifferentFromDefault = JSON.stringify({ ...aposition }) !== JSON.stringify({ ...apositionDefaults });	
	if (!isDifferentFromDefault) return extraProps;

	const updatedata = {}; 

	for (const key in aposition) {
		const val = aposition[key];
		const def = apositionDefaults[key];

		if (val === undefined) continue;

		if (JSON.stringify(val) !== JSON.stringify(def) && val !== '') {
			updatedata[key] = val;			
		}
	}

	attributes.aposition = updatedata;
	return extraProps;
};




addFilter(
	'blocks.registerBlockType', 
	'aver/aposition-attributes', 
	addAttributes
);

addFilter(
	'editor.BlockEdit', 
	'aver/aposition-advanced-control', 
	addInspectorControl
);

addFilter(
	'editor.BlockListBlock', 
	'aver/aposition-editor-class', 
	applyExtraClassEditor
);

addFilter( 
	'blocks.getSaveContent.extraProps',  
	'aver/aposition-save-class',  
	applyExtraClassSave 
);
